/* Lagom theme: stats module, ported from the prototype's main.js. Loads only when its section is on the page. */
(function () {
  'use strict';
  var L = window.Lagom; if (!L || !L.q) { return; }
  var q = L.q, qa = L.qa, motionOff = L.motionOff, MOTION = L.MOTION, CAPTURE = L.CAPTURE, IMG = L.assetBase || '';
  /* ---------- 2f. Odometer (M5) ----------
     Each digit of a stat becomes a vertical strip 0-9 that rolls to its value once the band is 40% visible (1.2 s,
     60 ms stagger per digit, once). The final text stays in the DOM for screen readers (visually hidden) and the
     strips are aria-hidden, so the numbers are correct without JS. In-page links (e.g. "Reviews" in the menu) finish
     the roll at once; coming back via the back/forward cache plays it again. Motion off: the final numbers at once. */
  (function () {
    var stats = q('.stats');
    var nums = qa('[data-count]');
    if (!stats || !nums.length || !('IntersectionObserver' in window)) { return; }
    if (motionOff()) { return; }
    var strips = [];
    nums.forEach(function (el) {
      var full = el.textContent;
      var sr = document.createElement('span'); sr.className = 'visually-hidden'; sr.textContent = full;
      var odo = document.createElement('span'); odo.className = 'odo'; odo.setAttribute('aria-hidden', 'true');
      var di = 0;
      full.split('').forEach(function (ch) {
        if (!/\d/.test(ch)) { odo.appendChild(document.createTextNode(ch)); return; }
        var digit = document.createElement('span'); digit.className = 'odo__digit';
        var strip = document.createElement('span'); strip.className = 'odo__strip';
        strip.style.setProperty('--n', ch); strip.style.setProperty('--d', (di * 60) + 'ms');
        for (var i = 0; i <= 9; i++) { var n = document.createElement('span'); n.textContent = String(i); strip.appendChild(n); }
        digit.appendChild(strip); odo.appendChild(digit); strips.push(strip); di += 1;
      });
      el.textContent = ''; el.appendChild(sr); el.appendChild(odo);
    });
    var done = false;
    function roll(instant) {
      if (done) { return; }
      done = true;
      if (instant) { strips.forEach(function (s) { s.style.transition = 'none'; }); }
      stats.classList.add('is-on');
    }
    var io;
    function watch() {
      io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); roll(false); }
      }, { threshold: 0.4 });
      io.observe(stats);
    }
    watch();
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (a && !done) { roll(true); }
    });
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) { return; }
      if (io) { io.disconnect(); }
      done = false;
      strips.forEach(function (s) { s.style.transition = ''; });
      stats.classList.remove('is-on');
      watch();
    });
  })();

})();
